const NBSP = ' ';

const LINE_START_TAGS = new Set(['P', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'LI', 'BLOCKQUOTE', 'DIV', 'TD', 'TH', 'BR']);

/**
 * Makes user-typed spaces survive HTML rendering (e.g. in emails), where runs of
 * spaces and leading spaces are collapsed. A space becomes &nbsp; when it starts a
 * line or follows another regular space, so "a   b" becomes "a &nbsp; b": spacing
 * is kept while normal spaces still allow line wrapping. Idempotent.
 */
export function preserveHtmlSpaces(html: string): string {
  if (!html || html.indexOf(' ') === -1) {
    return html;
  }

  // <template> content is inert: no scripts run and no resources load while parsing.
  const template = document.createElement('template');
  template.innerHTML = html;

  const walker = document.createTreeWalker(template.content, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
  let previousChar = '';
  let node = walker.nextNode();

  while (node) {
    if (node.nodeType === Node.ELEMENT_NODE) {
      if (LINE_START_TAGS.has((node as Element).tagName)) {
        previousChar = '';
      }
    } else {
      const text = node.nodeValue || '';
      let result = '';
      for (const char of text) {
        const out = char === ' ' && (previousChar === '' || previousChar === ' ') ? NBSP : char;
        result += out;
        previousChar = out;
      }
      node.nodeValue = result;
    }
    node = walker.nextNode();
  }

  return template.innerHTML;
}
